import React, { Component } from 'react';
import '../../css/modal.scss';
import { MessageOutlined } from '@ant-design/icons';
import Const from "../../const";

const msg = ['태도불량', '배송상태불량', '배송지연', '고객마찰', '기타'];

class BlindMsgInputModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, close } = this.props;
    const skinType = Const.skinType.toUpperCase();
    return (
      <>
        {isOpen ? (
          <>
            <div className="Modal-overlay-empty" onClick={close} />
            <div className="Modal">
              <div className="msginput-container">
                <div className="msginput-set" style={{ color: '#fff' }}>
                  {msg.map((value, index) => (
                    <div
                      key={index}
                      className={skinType === "GOGOIT" ? "gogoit-msginput-basic" : "msginput-basic"}
                      onClick={() => this.props.keyin(value)}>
                      <div>
                        <MessageOutlined style={{ marginRight: '10px' }} />
                        {value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}

export default BlindMsgInputModal;
